import { render } from "./UnusableChoicesSummaryDetailsLabel.vue?vue&type=template&id=189a2054&scoped=true"
import script from "./UnusableChoicesSummaryDetailsLabel.vue?vue&type=script&lang=js"
export * from "./UnusableChoicesSummaryDetailsLabel.vue?vue&type=script&lang=js"

import "./UnusableChoicesSummaryDetailsLabel.vue?vue&type=style&index=0&id=189a2054&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189a2054"]])

export default __exports__